import styled from "styled-components";

export const ImagesContainer = styled.div`
  overflow-x: scroll;
  margin: 51px -25px 0;
  -ms-overflow-style: none;
  scrollbar-width: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
  
  @media (min-width: 980px) {
    margin: 53px 0 0;
    width: auto;
    overflow-x: auto;
  }
`

export const ImagesRow = styled.div`
  max-width: 720px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 10px;
`

export const Logo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 auto;
  width: 112px;
  height: 112px;
  
  @media (min-width: 920px) {
    width: 122px;
    height: 122px;
  }
`